
import { useCallback, useState } from 'react';
interface LongreadCount {
    active: string;
    idList: string[];
    count: number;
}

export const useLongreadCounts = (): any => {
    const [data, setData] = useState<LongreadCount>({
        active: '',
        idList: [],
        count: 0
    })

    const setLongreadCounts = useCallback((active:string, idList: string[], count: number) => {
        if (data.active === active) return false;

        if (idList?.length !== data.idList?.length && count !== data?.count) {
            setData({
                active,
                idList, 
                count
            })
        }
    }, []);

      return [setLongreadCounts, data];
}

import { useCallback, useState } from 'react';
interface LongreadCount {
    active: string;
    idList: string[];
    count: number;
}

export const useLongreadCounts = (): any => {
    const [data, setData] = useState<LongreadCount>({
        active: '',
        idList: [],
        count: 0
    })

    const setLongreadCounts = useCallback((active:string, idList: string[], count: number) => {
        if (data.active === active) return false;

        if (idList?.length !== data.idList?.length && count !== data?.count) {
            setData({
                active,
                idList, 
                count
            })
        }
    }, []);

      return [setLongreadCounts, data];
}
